import validateField from "../validator/field_input_validate";
import { newsletterService } from "./newsletter.service";

class NewsletterController {
    constructor(service) {
        this.newsletter_service = service
    }

    async suscribe(data) {
        const { email } = data
        
        if (validateField.isEmptyFields(email))
            throw Error('Veuillez renseigner un e-mail')
        if (validateField.isTelNumber(email))
            throw Error('Veuillez saisir un e-mail')
        if (!validateField.isValidEmail(email))
            throw Error('Format e-mail invalide')

        try {
            const response = this.newsletter_service.suscribe(data)
            return response;
        } catch (error) {
            throw new Error(error.message)
        }
    }
}

export const newsletterController = new NewsletterController(newsletterService);